const initState = {
  appClicks: [],
  userLogins: []
}

const reportsReducer = (state = initState, action) => {
  switch (action.type) {
    case 'GET_APP_CLICKS':
    return {
      ...state,
      appClicks: action.appClicks
    }
    case 'GET_USER_LOGINS':
    return {
      ...state,
      userLogins: action.userLogins
    }
    case 'REFRESH_REPORTS':
      return {
        ...state,
        appClicks: state.appClicks,
        userLogins: action.userLogins
      }
    default: 
      return state;
  }
}

export default reportsReducer